import React, { useEffect, useState } from 'react';
import { onLocationRefused } from '../lib/apiClient';
import LocationRefused from './LocationRefused';
import './LocationGate.css';

/**
 * The one place a refused change gets explained.
 *
 * WHY THIS EXISTS, and it is a correction of my own work. Gordon chose to
 * block a change when the browser will not report a location. I built the
 * server side, the panel that explains it, and then wired that panel into
 * exactly two of the places a change can be made - the staff comment box and
 * the hand-back. There are seven recorded changes and a dozen screens that
 * make them: moving a card on the board, the status dropdown in the portal,
 * the contractor's own comment box, the time sheet, the edit panel, two
 * decision queues. Every one of those would have shown somebody
 * "Request failed with status code 428" and nothing else.
 *
 * For a rule that refuses writes, that is the difference between a
 * thirty-second fix and a phone call to Gordon.
 *
 * SO IT IS ANNOUNCED, NOT WIRED. lib/apiClient.js already does this for a
 * degraded answer - one response interceptor, a set of listeners, one banner
 * in the shell - and that pattern exists because the alternative is twelve
 * chances to forget one. A screen added next month that posts a comment is
 * covered without anybody remembering, which is the only kind of coverage
 * that survives.
 *
 * THE SCREEN STILL SEES ITS OWN FAILURE. The interceptor re-rejects, so the
 * form that made the request still knows it failed and still stops its
 * spinner. This adds an explanation beside that; it does not replace it.
 *
 * It does not block the page and it does not steal focus - somebody may well
 * want to read the ticket while they fix a browser setting. Dismissible, and
 * it clears itself the moment a change succeeds.
 */
export default function LocationGate() {
  const [error, setError] = useState(null);

  useEffect(() => onLocationRefused((err) => setError(err)), []);

  if (!error) return null;

  return (
    <div className="lg-wrap" role="region" aria-label="This change needs your location">
      <LocationRefused
        error={error}
        /*
         * No retry from here, deliberately. This component has no idea what
         * the request was - it saw a rejected promise, not a form - and a
         * "try again" that cannot try again is worse than no button. The
         * panel's own Retry asks the browser for a fresh fix and, on getting
         * one, dismisses: the person then presses the thing they pressed
         * before, which now works.
         */
        onRetry={() => setError(null)}
        onDismiss={() => setError(null)}
      />
    </div>
  );
}
